import { Injectable } from '@angular/core';
import { API_SERVICES_CONFIG, PaginatedResourceConfig, PortalHttpClient, UnifiedAnnouncementHttpResponse } from '@grid-ui/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class AnnouncementHttpService {
  private unifiedAnnouncementResourceConfig: PaginatedResourceConfig;

  constructor(private readonly http: PortalHttpClient) {
    this.unifiedAnnouncementResourceConfig = API_SERVICES_CONFIG.v4.unifiedAnnouncements._configuration;
  }

  public getUnifiedAnnouncements(): Observable<UnifiedAnnouncementHttpResponse> {
    return this.http
      .getPaginated<UnifiedAnnouncementHttpResponse>(this.unifiedAnnouncementResourceConfig, {
        queryParams: { active_only: true },
      })
      .pipe(map((context) => context.response));
  }
}
